import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromNoteActions } from '../actions';
import { INoteRequest, INoteResponse, INoteDocsRequest, INoteDocsResponse, IDownloadNoteDocumentRequest } from '../models/note.model';

export const noteFeatureKey = 'note';

export interface NoteState {
  noteRequest: string;
  noteSuccess: INoteResponse[];
  noteFailure: IGenericError<ErrorResponse>;

  noteDocsRequest: INoteDocsRequest;
  noteDocsSuccess: INoteDocsResponse[];
  noteDocsFailure: IGenericError<ErrorResponse>;

  loadDownloadNoteDocumentRequest: IDownloadNoteDocumentRequest;
  loadDownloadNoteDocumentResponse: string;
  loadDownloadNoteDocumentFailure: IGenericError<ErrorResponse>;
}

export const initialState: NoteState = {
  noteRequest: undefined,
  noteSuccess: undefined,
  noteFailure: undefined,

  noteDocsRequest: undefined,
  noteDocsSuccess: undefined,
  noteDocsFailure: undefined,

  loadDownloadNoteDocumentRequest: undefined,
  loadDownloadNoteDocumentResponse: undefined,
  loadDownloadNoteDocumentFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromNoteActions.loadNoteRequest, (state, action) => ({
    ...state,
    noteRequest: action.request
  })),
  on(fromNoteActions.loadNoteSuccess, (state, action) => ({
    ...state,
    noteSuccess: action.response
  })),
  on(fromNoteActions.loadNoteFailure, (state, action) => ({
    ...state,
    noteFailure: action.error
  })),

  on(fromNoteActions.loadNoteDocsRequest, (state, action) => ({
    ...state,
    noteDocsRequest: action.request
  })),
  on(fromNoteActions.loadNoteDocsSuccess, (state, action) => ({
    ...state,
    noteDocsSuccess: action.response
  })),
  on(fromNoteActions.loadNoteDocsFailure, (state, action) => ({
    ...state,
    noteDocsFailure: action.error
  })),

  on(fromNoteActions.loadDownloadNoteDocuments, (state, action) => ({
    ...state,
    loadDownloadNoteDocumentRequest: action.request
  })),
  on(fromNoteActions.loadDownloadNoteDocumentsSuccess, (state, action) => ({
    ...state,
    loadDownloadNoteDocumentResponse: action.response
  })),
  on(fromNoteActions.loadDownloadNoteDocumentsFailure, (state, action) => ({
    ...state,
    loadDownloadNoteDocumentFailure: action.error
  }))
);

export const getNoteRequest = (state: NoteState) => state.noteRequest;
export const getNoteSuccess = (state: NoteState) => {
  return state.noteSuccess;
};
export const getNoteFailure = (state: NoteState) => state.noteFailure;

export const getNoteDocsRequest = (state: NoteState) => state.noteDocsRequest;
export const getNoteDocsSuccess = (state: NoteState) => {
  return state.noteDocsSuccess;
};
export const getNoteDocsFailure = (state: NoteState) => state.noteDocsFailure;
